import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { ContactSection } from './components/ContactSection';
import { AboutSection } from './components/AboutSection';
import { GlobalReach } from './components/GlobalReach';
import { WeNeedSection } from './components/WeNeedSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-[#f0f7ff]" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <ContactSection data-id="element-5" />
        <AboutSection data-id="element-6" />
        <GlobalReach data-id="element-7" />
        <WeNeedSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}